import { NotificationIcon } from '@calizahq/react-components-v2'
import React from 'react'
import { useLocation } from 'react-router-dom'

type Props = {
  isUnreadNotifications: boolean
  numberOfUnreadNotifications: number
  onNavLinkPress: (path: string) => void
}

export const Notifications = ({ isUnreadNotifications, numberOfUnreadNotifications, onNavLinkPress }: Props) => {
  const { pathname } = useLocation()

  return (
    <button
      className={`${pathname === '/notifications' ? 'active-selection' : ''}`}
      onClick={() => onNavLinkPress('/notifications')}
    >
      <li>
        <NotificationIcon className={`${isUnreadNotifications ? 'text-red-300' : ''}`} />
        <span className={`font-bold ${isUnreadNotifications ? 'text-red-300' : ''}`}>
          Notifications {isUnreadNotifications ? ` (${numberOfUnreadNotifications})` : ''}
        </span>
      </li>
    </button>
  )
}
